import { extractFilterValues, isNotInFilter } from "@/hooks/useFilterOptions";
import { Filters } from "@/services/api/types";
import { isArray, isEmpty, isNull, map, sum } from "lodash";

export const hasActiveFilterValue = (value: any): boolean => {
  if (isNull(value)) return false;
  if (isNotInFilter(value)) {
    const notInValues = extractFilterValues(value);
    return !isEmpty(notInValues);
  }
  return isArray(value) ? !isEmpty(value) : true;
};

// Filters a view applied (activation or reset) rather than filters the user
// added. Tracked by object identity: the setter stores the same object.
const viewAppliedFilters = new WeakSet<Filters>();

export const markViewAppliedFilters = (filters: Filters): Filters => {
  viewAppliedFilters.add(filters);
  return filters;
};

export const isViewAppliedFilters = (filters: Filters): boolean =>
  viewAppliedFilters.has(filters);

export const getNumberOfActiveFilters = (
  filters: Filters,
  hiddenColumns?: string[]
) =>
  sum(
    map(filters, (value, key) =>
      !hiddenColumns?.includes(key) && hasActiveFilterValue(value) ? 1 : 0
    )
  );
